/*!
=========================================================
* 工事情報登録
=========================================================
*/
import React from "react";

import {
  Button,
  Card, CardHeader, CardBody, CardTitle,
  Table, Row, Col,
  Modal, ModalBody, ModalFooter
} from "reactstrap";
import InputText from '../FormParts/InputText'
import InputSelect from '../FormParts/InputSelect'
import InputRadio from '../FormParts/InputRadio'
import InputDatetime from '../FormParts/InputDatetime'
import CustomerSelectPopup from '../ViewParts/CustomerSelectPopup';
import Request from '../../common/Request';
import FormatCode from '../../common/FormatCode';
import GoogleMap from '../ViewParts/GoogleMap';
import {
  cst_prefecture,
  cst_send_destination_type,
  cst_register_type
} from '../../variables/codes_map';
import CustomTd from '../ViewParts/CustomTd';
import GsuiteAuth from '../../components/Auth/GsuiteAuth';
import WithRole from '../FormParts/ButtonWithRole';
import { GetMessage, getErrorCodes } from "../../variables/message";
import InputCheckBox from '../FormParts/InputCheckBox'
const moment = require("moment");
var domain = "";


class List extends React.Component {
  constructor(props) {
    super(props);

    const box_status = new URL(window.location.href).searchParams.get("box_status");
    // 遷移先に遷移元を示すパラメータを渡す
    const box_status_param = `?box_status=${box_status}`
    // 遷移元に戻るための設定
    const transition_url = box_status === "0" ? "/construction/list" : "/construction/new_customer";

    // 担当支店（新規登録の場合はログインユーザーの支店）
    const isNewRegist = this.props.location.pathname.includes("/construction/add/");

    this.state = {
      title: '',
      data: {
        values: {
          send_destination_type: cst_send_destination_type[0].default,
          register_type: cst_register_type[0].default,
          user_branch_natural_id: isNewRegist ? GsuiteAuth.get('user_branch_natural_id') : undefined,
        },
        errors: {},
        requiredData: {},
        site_name: ""
      },
      dialogData: {
        values: {
          update_processing_customer: 1
        },
      },
      customer1: {},
      customer2: {},
      map_data: [],
      regist_modal: false,
      error_modal: false,
      others_type: "",
      project_id: "",
      view: false,
      valid: true,
      error: {},
      customerTarget: '',
      showMap: false,
      box_status: box_status,
      box_status_param: box_status_param,
      transition_url: transition_url
    };

    this.customer_select_popup = React.createRef();
    this.subcontractor_select_popup = React.createRef();
    this.googlemap = React.createRef();
    this.toggleRegistModal = this.toggleRegistModal.bind(this);
    this.customerSelected = this.customerSelected.bind(this);
    this.onLocationChange = this.onLocationChange.bind(this);
    this.updateLocation = this.updateLocation.bind(this);
    this.validateCallback = this.validateCallback.bind(this);
    this.alertFromMap = this.alertFromMap.bind(this)
    this.validate = this.validate.bind(this)
    this.alertDateCheck = this.alertDateCheck.bind(this)
    this.validateDialogCallback = this.validateDialogCallback.bind(this);
  }

  onLocationChange(latitude, longitude) {
    const { values } = this.state.data;
    this.setState({
      data: {
        ...this.state.data,
        values: {
          ...values,
          latitude: latitude,
          longitude: longitude
        }
      }
    });
  }

  customerSelected(customer, target = 'customer1') {
    if (customer) {
      this.setState({
        customer_user_ulid: customer.customer_user_ulid,
        [target]: customer,
      });
    }
  }

  // 初期ロード用
  async componentDidMount() {
    /*　ここは開発者が記述　*/
    if (this.props.match.params.others_type !== undefined) {
      this.setState({ others_type: this.props.match.params.others_type });
    }

    const url = domain + '/api/construction'

    if (this.props.match.params.project_id !== undefined) {
      await Request.get(url + "/" + this.props.match.params.project_id, {}, async res => {
        if (this.props.data_view_flag == 2 && (res.Data.user_branch != GsuiteAuth.get('user_branch_id'))) {
          this.props.pageChangeAlert.current.inactivate();
          this.props.history.push('/forbidden')
          return
        } else {
          const customerUserApiEndPoint = '/api/customer/user';
          res.Data.customer_user_natural_id && await Request.get(customerUserApiEndPoint, {
            customer_user_natural_id: res.Data.customer_user_natural_id
          }, res => {
            this.setState({
              customer1: res.Data[0]
            })
          })
          res.Data.subcontract_customer_user_natural_id && await Request.get(customerUserApiEndPoint, {
            customer_user_natural_id: res.Data.subcontract_customer_user_natural_id
          }, res => {
            this.setState({
              customer2: res.Data[0]
            })
          })

          this.setState({
            data: {
              ...this.state.data,
              values: res.Data,
              site_name: res.Data["site_name"]
            },
            view: true,
            showMap: true
          }, async () => {
            const requiredCheckedData = await Request.getRequiredData(url, this.state.data)
            this.setState({
              data: {
                ...requiredCheckedData,
                requiredData: {
                  ...requiredCheckedData.requiredData,
                  site_customer_user_name: [GetMessage(2024)],
                  site_customer_user_tel: [GetMessage(2024)],
                },
                errors: {
                  ...(res.Data.register_type == 1 && !res.Data.site_customer_user_name ? { site_customer_user_name: [GetMessage(2024)] } : {}),
                  ...(res.Data.register_type == 1 && !res.Data.site_customer_user_tel ? { site_customer_user_tel: [GetMessage(2024)] } : {}),
                }
              }
            })
            this.ButtonWithRole = WithRole(Button, this.props.buttons, this.state.view ? this.state.data.values : undefined)
          });
        }
      });
    } else {
      const requiredCheckedData = await Request.getRequiredData(url, this.state.data)
      this.setState({
        data: {
          ...requiredCheckedData,
          requiredData: {
            ...requiredCheckedData.requiredData,
          }
        },
        showMap: true
      }, () => {
        this.ButtonWithRole = WithRole(Button, this.props.buttons, this.state.view ? this.state.data.values : undefined)
      })
    }

    // 担当支店用にランドマーク支店マスタの取得
    Request.get("/api/landmark/user_branch", {}, res => {
      const user_branch_list = res.Data.map((prop, key) => {
        return {
          value: prop.user_branch_natural_id,
          label: prop.user_branch_name,
          user_branch_natural_id: prop.user_branch_natural_id,
          id: prop.id
        }
      })
      this.setState({ landmark_user_branch: user_branch_list });
    })
  }

  toggleRegistModal() {
    this.setState({
      regist_modal: !this.state.regist_modal
    });
  }

  regist() {
    const {
      customer_id,
      customer_natural_id,
      customer_branch_id,
      customer_branch_natural_id,
      id: customer_user_id,
      customer_user_natural_id,
    } = this.state.customer1
    const {
      customer_id: subcontract_customer_id,
      customer_natural_id: subcontract_customer_natural_id,
      customer_branch_id: subcontract_customer_branch_id,
      customer_branch_natural_id: subcontract_customer_branch_natural_id,
      id: subcontract_customer_user_id,
      customer_user_natural_id: subcontract_customer_user_natural_id,
    } = this.state.customer2
    const {
      project_start_date,
      project_finish_date
    } = this.state.data.values
    const params = {
      ...this.state.data.values,
      customer_id,
      customer_natural_id,
      customer_branch_id,
      customer_branch_natural_id,
      customer_user_id,
      customer_user: customer_user_id,
      customer_user_natural_id,
      subcontract_customer_id,
      subcontract_customer_natural_id,
      subcontract_customer_branch_id,
      subcontract_customer_branch_natural_id,
      subcontract_customer_user: subcontract_customer_user_id,
      subcontract_customer_user_natural_id,
      user_branch_id: this.state.landmark_user_branch.find(data => data.value === this.state.data.values.user_branch_natural_id).id,
      user_branch_natural_id: this.state.data.values.user_branch_natural_id,
      project_start_date: project_start_date === "" ? null : project_start_date,
      project_finish_date: project_finish_date === "" ? null : project_finish_date,
      update_processing_customer: this.state.dialogData.values.update_processing_customer
    };
    const url = domain + '/api/construction';
    if (this.state.view === false) {
      Request.post(url, params, res => {
        if (res.Data.ulid) {
          this.props.pageChangeAlert.current.inactivate();
          switch (this.state.others_type) {
            case "0":
            case "1":
            case "2":
            case "3":
              this.props.history.push('/construction/parking/add/' + this.state.others_type + '/' + res.Data.ulid + this.state.box_status_param);
              break;
            case "4":
            case "5":
            case "6":
            case "7":
              this.props.history.push('/construction/other/add/' + this.state.others_type + '/' + res.Data.ulid + this.state.box_status_param);
              break;
          }
        } else {
          if (res.Code == 800) {
            this.setState({
              data: {
                ...this.state.data,
                errors: res.Data,
              }
            })
          } else {
            const messageObj = (res.Code >= 800)
              ? { messageNo: [2402, ...(res.Data.length ? res.Data.map(error => error[0]) : [res.Data.error])] }
              : { messageNo: 2402 }
            this.props.alertModal.current.showErrorModal(messageObj);
          }
        }
      });
    } else {
      Request.put(url + "/" + this.props.match.params.project_id, params, res => {
        if (res.Data.ulid) {
          this.props.pageChangeAlert.current.inactivate();
          this.props.history.push(`/construction/detail/${this.props.match.params.project_id}${this.state.box_status_param}`)
        } else {
          if (res.Code == 800) {
            this.setState({
              data: {
                ...this.state.data,
                errors: res.Data,
              }
            })
          } else {
            const messageObj = (res.Code >= 800)
              ? { messageNo: [2403, ...(res.Data.length ? res.Data.map(error => error[0]) : [res.Data.error])] }
              : { messageNo: 2403 }
            this.props.alertModal.current.showErrorModal(messageObj);
          }
        }
      });
    }
  }

  updateLocation() {
    const site_pref = FormatCode.decode("cst_prefecture", this.state.data.values.site_prefecture) || FormatCode.decode("cst_prefecture", cst_prefecture[0].value)
    const site_city = this.state.data.values.site_city || ""
    const site_address = this.state.data.values.site_address || ""
    const fullAddress = (site_pref + site_city + site_address)
    this.googlemap.current.setAddress(fullAddress);
  }

  button_name() {
    if (this.state.view === false) {
      return "登録";
    } else {
      return "更新";
    }
  }

  validateCallback(newData, callback = () => { }) {
    if (
      this.state.data.values.construction_number != newData.values.construction_number
      || this.state.data.values.site_name != newData.values.site_name
    ) {
      const {
        construction_number,
        site_name
      } = newData.values
      // site_name
      const constructionFlag = this.state.data.values.construction_number != newData.values.construction_number
      Request.get('/api/construction/check', {
        ...(this.state.data.values.construction_number != newData.values.construction_number
          ? { construction_number: construction_number } : {}),
        ...(this.state.data.values.site_name != newData.values.site_name
          ? { site_name: site_name } : {}),
        ...(this.props.match.params.project_id
          ? { project_id: this.state.data.values.id }
          : {})
      }, res => {
        if (res.Data.length > 0) {
          this.props.alertModal.current.showErrorModal({
            title: 'アラート',
            messageNo: (constructionFlag ? 2412 : 2413)
          });
        }
      }, () => { }, () => { }, true, false)
    }

    const mergedData = {
      ...this.state.data,
      ...this.alertDateCheck(newData)
    }
    this.setState({
      data: {
        ...mergedData
      }
    }, () => callback())
  }

  validate() {
    const { customer_id } = this.state.customer1;
    const { latitude, longitude } = this.state.data.values;

    let message = getErrorCodes(this.state.data.errors)

    //元請情報を選択してない場合
    if (!customer_id) {
      message.push(2421)
    }

    //入力住所で検索してない場合
    if (!latitude || !longitude) {
      message.push(2422)
    }

    if (message.length > 0) {
      this.props.alertModal.current.showErrorModal({ messageNo: message });
      return false;
    }
    return true;
  }

  alertFromMap(messageNo) {
    this.props.alertModal.current.showErrorModal({ messageNo });
  }

  alertDateCheck(newData) {
    const {
      project_start_date,
      project_finish_date
    } = newData.values
    const {
      project_start_date: prev_project_start_date,
    } = this.state.data.values
    if (project_start_date && project_finish_date && (moment(project_start_date) > moment(project_finish_date))) {
      return {
        ...newData,
        errors: {
          ...newData.errors,
          ...{ [(prev_project_start_date === project_start_date ? 'project_finish_date' : 'project_start_date')]: [GetMessage(2431)] },
        }
      }
    } else {
      return newData
    }
  }

  validateDialogCallback(newData, callback = () => { }) {
    this.setState({
      dialogData: {
        ...newData,
        values: {
          ...newData.values,
        }
      }
    }, () => callback())
  }

  render() {
    const {
      data: {
        values,
      },
      customer1,
      customer2,
      customerTarget
    } = this.state
    console.log('state', this.state)
    const ButtonWithRole = this.ButtonWithRole || WithRole(Button, this.props.buttons, this.state.view ? this.state.data.values : undefined)
    const customerDuplicationFlag = customer1.customer_id && customer1.customer_id === customer2.customer_id;

    const updateProcessingCustomerVisible = customer1.customer_user_natural_id != this.state.data.values.customer_user_natural_id || customer2.customer_user_natural_id != this.state.data.values.subcontract_customer_user_natural_id;
    return (
      <>
        <div className="content">
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <Row>
                    <Col md="6">
                      <CardTitle tag="h3">{this.state.view ? "工事情報更新" : "工事情報登録"}</CardTitle>
                    </Col>
                  </Row>
                </CardHeader>
                <Col md="11" className="detail">
                  <CardBody>
                    <Row>
                      <CardTitle tag="h4">管理情報</CardTitle>
                      <Col md='12'>
                        <Table>
                          <tbody>
                            <tr>
                              <CustomTd label='メモ'
                                name='PROJECT__system_memo'
                                copy={false}
                                rootData={this.state.data}
                                value={
                                  <InputText multiline={true}
                                    validateCallback={this.validateCallback}
                                    validateType='regist'
                                  />
                                }
                              />
                            </tr>
                          </tbody>
                        </Table>
                      </Col>
                      <CardTitle tag="h4">案件情報</CardTitle>
                      <Col md='12' className="text-right">
                        <Button onClick={() => {
                          this.setState({
                            customerTarget: 'customer1'
                          }, () => {
                            if (this.state.view) {
                              this.customer_select_popup.current.setSelectedDataWithId({
                                customer_natural_id: this.state.data.values.customer_natural_id,
                                customer_branch_natural_id: this.state.data.values.customer_branch_natural_id,
                                customer_user_natural_id: this.state.data.values.customer_user_natural_id
                              });
                            }
                            this.customer_select_popup.current.show();
                          })
                        }}>顧客マスタから選択</Button>
                      </Col>
                    </Row>
                    <Table>
                      <tbody>
                        <tr>
                          {/* <th rowSpan='4' className='text-left'>会社情報</th> */}
                          <CustomTd
                            label="会社名"
                            name="CUSTOMER__customer_name"
                            copy={false}
                            colSpan="3"
                            data={customer1}
                          />
                        </tr>
                        <tr>
                          <CustomTd
                            label="支店名"
                            name="CUSTOMER_BRANCH__customer_branch_name"
                            copy={false}
                            colSpan="3"
                            data={customer1}
                          />
                        </tr>
                        <tr>
                          <CustomTd
                            label="電話番号"
                            name="CUSTOMER_BRANCH__customer_branch_tel"
                            copy={false}
                            colSpan="3"
                            data={customer1}
                          />
                        </tr>
                        <tr>
                          <CustomTd
                            label="FAX番号"
                            name="CUSTOMER_BRANCH__customer_branch_fax"
                            copy={false}
                            colSpan="3"
                            data={customer1}
                          />
                        </tr>
                        <tr>
                          {/* <th rowSpan='3' className='text-left'>担当者</th> */}
                          <CustomTd
                            label="顧客担当者"
                            name="CUSTOMER_USER__customer_user_name"
                            copy={false}
                            colSpan="3"
                            data={customer1}
                          />
                        </tr>
                        <tr>
                          <CustomTd
                            label="携帯電話番号"
                            name="CUSTOMER_USER__customer_user_tel"
                            copy={false}
                            colSpan="3"
                            data={customer1}
                          />
                        </tr>
                        <tr>
                          <CustomTd
                            label="固定電話番号"
                            name="CUSTOMER_USER__customer_user_tel2"
                            copy={false}
                            colSpan="3"
                            data={customer1}
                          />
                        </tr>
                        <tr>
                          <CustomTd
                            label="メールアドレス"
                            name="CUSTOMER_USER__customer_user_email"
                            copy={false}
                            colSpan="3"
                            data={customer1}
                          />
                        </tr>
                      </tbody>
                    </Table>
                    <Row>
                      <Col md='12' className="text-right">
                        <Button
                          style={{ marginRight: "5px" }}
                          disabled={!Boolean(customer2.id)}
                          onClick={() => {
                            this.setState({
                              customer2: {
                                customer_id: null,
                                customer_natural_id: null,
                                customer_branch_id: null,
                                customer_branch_natural_id: null,
                                id: null,
                                customer_user_natural_id: null,
                              },
                              data: {
                                ...this.state.data,
                                values: {
                                  ...this.state.data.values,
                                  send_destination_type: 0
                                }
                              }
                            })
                          }}>下請入力クリア</Button>

                        <Button
                          disabled={!Boolean(customer1.id) || this.state.data.values.register_type === 1}
                          onClick={() => {
                            this.setState({
                              customerTarget: 'customer2'
                            }, () => {
                              if (this.state.view && this.state.data.values.subcontract_customer_user_natural_id) {
                                this.customer_select_popup.current.setSelectedDataWithId({
                                  customer_natural_id: this.state.data.values.subcontract_customer_natural_id,
                                  customer_branch_natural_id: this.state.data.values.subcontract_customer_branch_natural_id,
                                  customer_user_natural_id: this.state.data.values.subcontract_customer_user_natural_id
                                });
                              }
                              this.subcontractor_select_popup.current.show();
                            })
                          }}>顧客マスタから選択</Button>
                      </Col>
                    </Row>
                    <Table>
                      <tbody>
                        <tr>
                          {/* <th rowSpan='4' className='text-left'>下請顧客会社情報</th> */}
                          <CustomTd
                            label="会社名（下請）"
                            name="CUSTOMER__customer_name"
                            copy={false}
                            colSpan="3"
                            data={customer2}
                          />
                        </tr>
                        <tr>
                          <CustomTd
                            label="支店名（下請）"
                            name="CUSTOMER_BRANCH__customer_branch_name"
                            copy={false}
                            colSpan="3"
                            data={customer2}
                          />
                        </tr>
                        <tr>
                          <CustomTd
                            label="電話番号（下請）"
                            name="CUSTOMER_BRANCH__customer_branch_tel"
                            copy={false}
                            colSpan="3"
                            data={customer2}
                          />
                        </tr>
                        <tr>
                          <CustomTd
                            label="FAX番号（下請）"
                            name="CUSTOMER_BRANCH__customer_branch_fax"
                            copy={false}
                            colSpan="3"
                            data={customer2}
                          />
                        </tr>
                        <tr>
                          {/* <th rowSpan='3' className='text-left'>下請顧客担当者</th> */}
                          <CustomTd
                            label="顧客担当者（下請）"
                            name="CUSTOMER_USER__customer_user_name"
                            copy={false}
                            colSpan="3"
                            data={customer2}
                          />
                        </tr>
                        <tr>
                          <CustomTd
                            label="携帯電話番号（下請）"
                            name="CUSTOMER_USER__customer_user_tel"
                            copy={false}
                            colSpan="3"
                            data={customer2}
                          />
                        </tr>
                        <tr>
                          <CustomTd
                            label="固定電話番号（下請）"
                            name="CUSTOMER_USER__customer_user_tel2"
                            copy={false}
                            colSpan="3"
                            data={customer2}
                          />
                        </tr>
                        <tr>
                          <CustomTd
                            label="メールアドレス（下請）"
                            name="CUSTOMER_USER__customer_user_email"
                            copy={false}
                            colSpan="3"
                            data={customer2}
                          />
                        </tr>
                      </tbody>
                    </Table>
                    <p style={{ color: "red", marginTop: -15, marginBottom: 25 }}>{customerDuplicationFlag && GetMessage(2441)}</p>
                    <Table>
                      <tbody>
                        {this.state.view && this.state.data.values.register_type === 1 && <>
                          <tr>
                            <CustomTd
                              label="現場担当者名"
                              colSpan="3"
                              name="PROJECT__site_customer_user_name"
                              rootData={this.state.data}
                              value={
                                <InputText
                                  validateCallback={this.validateCallback}
                                  validateType="regist"
                                />
                              }
                            />
                          </tr>
                          <tr>
                            <CustomTd
                              label="現場担当者電話番号"
                              colSpan="3"
                              name="PROJECT__site_customer_user_tel"
                              rootData={this.state.data}
                              value={
                                <InputText
                                  validateCallback={this.validateCallback}
                                  validateType="regist"
                                />
                              } />
                          </tr>
                        </>}

                        <tr>
                          <CustomTd label="工事番号"
                            name="PROJECT__construction_number"
                            colSpan="3"
                            rootData={this.state.data}
                            value={
                              <InputText
                                validateCallback={this.validateCallback}
                                validateType="regist"
                              />
                            } />
                        </tr>
                        <tr>
                          <CustomTd label="現場名"
                            name="PROJECT__site_name"
                            colSpan="3"
                            rootData={this.state.data}
                            value={
                              <InputText
                                validateCallback={this.validateCallback}
                                validateType="regist"
                                hasKanaInput={true}
                              />
                            } />
                        </tr>
                        <tr>
                          <CustomTd label="現場名（カナ）"
                            name="PROJECT__site_name_kana"
                            colSpan="3"
                            rootData={this.state.data}
                            value={
                              <InputText
                                labelOn={false}
                                validateCallback={this.validateCallback}
                                validateType="regist" />
                            } />
                        </tr>
                        <tr>
                          <CustomTd label='工事開始日'
                            name='PROJECT__project_start_date'
                            colSpan="3"
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputDatetime
                                validateCallback={this.validateCallback}
                                validateType='regist'
                              />
                            }
                          />
                        </tr>
                        <tr>
                          <CustomTd label='工事終了日'
                            name='PROJECT__project_finish_date'
                            colSpan="3"
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputDatetime
                                validateCallback={this.validateCallback}
                                validateType='regist'
                              />
                            }
                          />
                        </tr>
                        <tr>
                          <CustomTd label="都道府県"
                            name="PROJECT__site_prefecture"
                            colSpan="3"
                            value={
                              <InputSelect
                                options={cst_prefecture}
                                validateCallback={this.validateCallback}
                                rootData={this.state.data}
                                isSearchable={true}
                                isNull={true}
                                validateType="regist"
                              />
                            } />
                        </tr>
                        <tr>
                          <CustomTd label="市区町村"
                            name="PROJECT__site_city"
                            colSpan="3"
                            value={
                              <InputText
                                labelOn={false}
                                validateCallback={this.validateCallback}
                                rootData={this.state.data}
                                validateType="regist" />
                            } />
                        </tr>
                        <tr>
                          <CustomTd label="番地（町名以降）"
                            name="PROJECT__site_address"
                            colSpan="3"
                            value={
                              <InputText
                                labelOn={false}
                                validateCallback={this.validateCallback}
                                rootData={this.state.data}
                                validateType="regist" />
                            } />
                        </tr>
                        <tr>
                          <CustomTd label='送付先'
                            name='PROJECT__send_destination_type'
                            colSpan="3"
                            rootData={this.state.data}
                            value={
                              <InputRadio
                                options={cst_send_destination_type}
                                validateCallback={this.validateCallback}
                                validateType='regist'
                                disabled={!(this.state.customer1.id && this.state.customer2.id)}
                              />
                            }
                          />
                        </tr>
                        <tr>
                          <CustomTd
                            label="緯度"
                            name="PROJECT__latitude"
                            data={values}
                          />
                          <CustomTd
                            label="経度"
                            name="PROJECT__longitude"
                            data={values}
                          />
                        </tr>
                        <tr>
                          <CustomTd
                            label="地図"
                            colSpan="3"
                            value={this.state.showMap && <>
                              <GoogleMap
                                ref={this.googlemap}
                                alertModal={this.alertFromMap}
                                center={{
                                  latitude: this.state.data.values && this.state.data.values.latitude,
                                  longitude: this.state.data.values && this.state.data.values.longitude,
                                  address: this.state.data.values && this.state.map_data.site_pref + this.state.map_data.site_city + this.state.map_data.site_address
                                }}
                                aerial={false}
                                onLocationChange={this.onLocationChange}
                                editable={true}
                              />
                              <Button style={{ float: 'right', marginTop: '5px' }} className="btn-dribbble btn-sm" onClick={this.updateLocation}>入力住所で検索</Button>
                            </>}
                          />
                        </tr>
                        <tr>
                          <CustomTd label='担当支店'
                            name='PROJECT__user_branch_natural_id'
                            colSpan="3"
                            value={
                              <InputSelect label="担当支店"
                                labelOn={false}
                                validateCallback={this.validateCallback}
                                rootData={this.state.data}
                                validateType="regist"
                                options={this.state.landmark_user_branch}
                              />
                            }
                          />
                        </tr>
                      </tbody>
                    </Table>
                  </CardBody>
                </Col>
                <Row md='12' className="detail">
                  <Col md='6' className="text-center">
                    <Button color="secondary" onClick={() => {
                      if (this.state.view === false) {
                        this.props.history.push(this.state.transition_url)
                      } else {
                        this.props.history.push(`/construction/detail/${this.props.match.params.project_id}${this.state.box_status_param}`)
                      }
                    }}>キャンセル</Button>
                  </Col>
                  <Col md='6' className="text-center">
                    <ButtonWithRole button_id={this.state.view ? "BTN_A1_04_00950" : "BTN_A1_02_00570"} color="info"
                      onClick={() => {
                        if (this.validate()) {
                          this.toggleRegistModal()
                        }
                      }}>
                      {this.button_name()}
                    </ButtonWithRole>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </div>
        <Modal isOpen={this.state.regist_modal} toggle={this.toggleRegistModal}>
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.toggleRegistModal}>
              <i className="tim-icons icon-simple-remove"></i>
            </button>
            <h5 className="modal-title">{this.button_name()}</h5>
          </div>
          <ModalBody>
            <p>{this.button_name()}しますか？</p>
            {this.state.view && updateProcessingCustomerVisible && <InputCheckBox
              label='契約終了日以内の依頼情報の顧客担当者を更新する'
              name='NODB__update_processing_customer'
              labelOn={false}
              checkedValue={1}
              uncheckedValue={0}
              validateCallback={this.validateDialogCallback}
              rootData={this.state.dialogData} />}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggleRegistModal}>
              いいえ
            </Button>
            <ButtonWithRole button_id={this.state.view ? "BTN_A1_04_01140" : "BTN_A1_02_00760"} color="info" onClick={() => { this.toggleRegistModal(); this.regist() }}>
              はい
            </ButtonWithRole>
          </ModalFooter>
        </Modal>
        <CustomerSelectPopup
          buttons={this.props.buttons}
          view={this.state.view}
          ref={this.customer_select_popup}
          customerSelectedCallback={(customer) => this.customerSelected(customer, customerTarget)}
        />
        <CustomerSelectPopup
          buttons={this.props.buttons}
          view={this.state.view}
          ref={this.subcontractor_select_popup}
          customerSelectedCallback={(customer) => this.customerSelected(customer, customerTarget)}
        />
      </>

    );
  }
}

export default List;
